<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
        v-if="showQuery"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <order-drop v-model="dataForm.orderCode" size="mini"></order-drop>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="tool-box" v-if="showTool">
      <file-link file-type="back" type="primary" file-url="/erp/export/order-detail" :params="dataForm">导出EXCEL
      </file-link>
      <el-button class="item" type="primary" size="mini" @click="doGroup">品番分组</el-button>
      <el-button class="item" type="warning" @click="$refs.appendOrderDetailUploader.init()" size="mini">追加品番
      </el-button>
      <el-button class="item" type="danger" @click="clearBom" size="mini">清空单耗</el-button>
    </div>
    <SweetTable ref="table" api-version="v2" url="/erp/order/detail/page" :selection="showSelection"
                :before-table-binding="beforeTableBinding" :query-form="dataForm"
                :default-query-params="defaultQueryParams" :auto-load="autoLoad" :is-page="hasPage" :height="height">
      <el-table-column label="订单编号" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <!--      <el-table-column label="系统编号"  prop="product.sysCode" width="80" header-align="center" align="center" :show-overflow-tooltip="true">-->
      <!--      </el-table-column>-->
      <el-table-column label="分组名称" prop="groupName" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品番号" prop="product.code" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" prop="product.skuCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" prop="product.name" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" prop="product.nameZh" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="product.color"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="product.size"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="amount"
          label="销售单价"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="boxSendCount"
          label="已发货"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="操作"
          header-align="center"
          align="center"
          v-if="showOptColumn"
          width="160" fixed="right"
      >
        <template #default="{row}">
          <el-button type="text"
                     v-if="$hasPermission('order:detail:edit')&&row.orderStatus===10&&hideButtons.indexOf('edit')===-1"
                     @click="doEdit(row)">修改
          </el-button>
          <el-button type="text" @click="showBomSaveDialog(row)" v-if="row.orderStatus!==200">
            单耗设置{{ (row.bomCount > 0) ? `【${row.bomCount}】` : `` }}
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <el-dialog
        :visible.sync="groupDialogVisible"
        title="设置分组"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
    >
      <el-form
          :model="groupForm"
          :rules="groupRule"
          ref="groupForm"
          label-width="120px"
      >
        <el-form-item label="分组名称：" prop="groupName">
          <OrderDetailGroup v-model="groupForm.groupName" :order-id="orderId" :allow-create="true"></OrderDetailGroup>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <div style="display: flex;justify-content: space-between">
          <div>
            <tool-tip>可以输入新分组名称创建分组，也可以选择已有的分组</tool-tip>
          </div>
          <div>
            <el-button size="mini" @click="groupDialogVisible=false">{{ $t('cancel') }}</el-button>
            <el-button size="mini" type="primary" @click="groupFormSubmitHandle">保存</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <common-upload
        ref="appendOrderDetailUploader"
        @success="reload"
        uploadUrl="/trade/order/detail/append"
        templateUrl="/static/template/合同批量导入模板.xlsx"
        title="追加合同品番"
        version="v2
"
    ></common-upload>
    <OrderDetailEditDialog ref="OrderDetailEditDialog" @refresh="getDataList"></OrderDetailEditDialog>
    <BomSaveDialog ref="bomSaveDialog" @change="getDataList"></BomSaveDialog>
  </div>
</template>

<script>
import OrderDetailEditDialog from '@/views/modules/erp/order/detail/edit-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import { countValidator } from '@/utils/validate'
import OrderDetailGroup from '@/components/OrderDetailGroup.vue'
import BomSaveDialog from '@/views/modules/trade/bom/save'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'OrderDetailTable',
  mixins: [SweetTable],
  components: { OrderDetailEditDialog, OrderDetailGroup, BomSaveDialog, FileLink },
  props: {
    hideButtons: {
      type: Array,
      default: () => []
    },
    showQuery: {
      type: Boolean,
      default: true
    },
    showOptColumn: {
      type: Boolean,
      default: true
    },
    showTool: {
      type: Boolean,
      default: true
    },
    showSelection: {
      type: Boolean,
      default: true
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
      }
    },
    hasPage: {
      type: Boolean,
      default: true
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      productGroupList: [],
      groupForm: {
        ids: [],
        groupName: ''
      },
      orderId: null,
      groupRule: {
        groupName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          }
        ],
      },
      groupDialogVisible: false,
      dataForm: {
        orderCode: '',
        productCode: '',
        skuCode: '',
        nameZh: '',
        productName: '',
        productColor: '',
        productSize: '',
      },
    }
  },
  methods: {
    //清空单耗
    async clearBom () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error(`请选择要清空单耗的品番`)
      }
      try {
        await this.$confirm(`确定要清空${rows.length}个品番的单耗吗？`, '操作提示')
        await this.$confirm(`再次确定要清空${rows.length}个品番的单耗吗？该操作无法撤销。`, '操作提示')
        await this.$api2.post(`/erp/bom/clear`, { ids: rows.map(item => item.id) })
        this.getDataList()
        this.$message.success('操作成功')
      } catch (e) {
        console.log(e)
      }
    },
    showBomSaveDialog (row) {
      this.$refs.bomSaveDialog.parentId = row.id
      this.$refs.bomSaveDialog.init()
    },
    doEdit (row) {
      this.$refs.OrderDetailEditDialog.id = row.id
      this.$refs.OrderDetailEditDialog.init()
    },
    async doGroup () {
      let dataList = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error(`请选择要分组的品番`)
      }
      //检查选择的品番是否为一个订单
      let orderId = dataList[0].agreementId
      for (let i = 0; i < dataList.length; i++) {
        let row = dataList[i]
        if (row.agreementId !== orderId) {
          return this.$message.error(`选择的品番不在一个订单下`)
        }
      }
      //显示分组弹窗
      this.orderId = orderId
      this.groupForm = {
        ids: dataList.map(item => item.id),
        groupName: ''
      }
      this.groupDialogVisible = true
      this.$nextTick(() => {
        this.$refs.groupForm.clearValidate()
      })
    },
    beforeTableBinding (dataList) {
    },
    groupFormSubmitHandle () {
      this.$refs.groupForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$api2.post(`/erp/order/detail/groups`, this.groupForm).then(res => {
          this.$message.success('操作成功')
          this.groupDialogVisible = false
          this.getDataList()
        })
      })
    }
  },
}
</script>
